import React, { useContext } from "react";

import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  SvgIcon,
} from "@mui/material";

import {
  HomeRounded,
  CorporateFare,
  PlaceRounded,
  ManageAccounts,
  AssignmentInd,
  SchoolRounded,
  MenuBookRounded,
  Plagiarism,
  AccountBalanceRounded,
  GroupsOutlined,
  FolderCopy,
  AddBox,
  AddHomeWork,
  LibraryBooksRounded,
  DescriptionRounded,
  FactCheckRounded,
  LockRounded,
} from "@mui/icons-material";

import { useLocation, useNavigate } from "react-router-dom";
import { CondicaoContext } from "../contexto";
import { ajustarTamanhoFonteAdmin } from "../estilos/global";

// Ícone já utilizado na administração de SREs.
export function BuildingsFillIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path d="M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2 11h1v1H2zm2 0h1v1H4zm-1 2v1H2v-1zm1 0h1v1H4zm9-10v1h-1V3zM8 5h1v1H8zm1 2v1H8V7zM8 9h1v1H8zm2 0h1v1h-1zm-1 2v1H8v-1zm1 0h1v1h-1zm3-2v1h-1V9zm-1 2h1v1h-1zm-2-4h1v1h-1zm3 0v1h-1V7zm-2-2v1h-1V5zm1 0h1v1h-1z" />
    </SvgIcon>
  );
}

export default function ItemList({
  onNavigate = () => {},
  visualNovo = false,
  expandido = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const { role, firstAccess, condicao, mantenedoraRegistrada } =
    useContext(CondicaoContext);

  let itens = [];

  // ADMINISTRADOR
  if (role === "admin") {
    itens = [
      {
        texto: "Início",
        rota: "/admin/painel",
        Icone: HomeRounded,
      },
      {
        texto: "SREs",
        rota: "/admin/visualizar/sre",
        Icone: BuildingsFillIcon,
      },
      {
        texto: "Cidades",

        rota: "/admin/visualizar/cidade",

        Icone: PlaceRounded,
      },

      {
        texto: "Catálogo de Ensino",
        rota: "/admin/catalogo-ensino",
        Icone: MenuBookRounded,
      },
    ];
  }

  // SRE
  else if (role === "superintendent") {
    itens = firstAccess
      ? [
          {
            texto: "Trocar Credenciais",
            rota: "/trocar-credenciais",
            Icone: AssignmentInd,
          },
        ]
      : [
          {
            texto: "Início",
            rota: "/admin",
            Icone: HomeRounded,
          },
          {
            texto: "Processos",
            rota: "/admin/processo",
            Icone: FolderCopy,
          },
          {
            texto: "Documentos",
            rota: "/admin/cadastro-documento",
            Icone: DescriptionRounded,
          },
          {
            texto: "Etapas / Modalidades",
            rota: "/admin/visualizar/modalidade",
            Icone: MenuBookRounded,
          },
          {
            texto: "Modelos e Roteiros",
            rota: "/modelos",
            Icone: LibraryBooksRounded,
          },
          {
            texto: "Lista de Usuários",
            rota: "/admin/usuarios",
            Icone: ManageAccounts,
          },
        ];
  }

  // ANALISTA
  else if (role === "analyst") {
    itens = [
      {
        texto: "Início",
        rota: "/analista/painel",
        Icone: HomeRounded,
      },
      {
        texto: "Processos",
        rota: "/analise",
        Icone: Plagiarism,
      },
      {
        texto: "Cadastros",
        rota: "/analise_cadastro",
        Icone: FactCheckRounded,
      },
      {
        texto: "Escolas",
        rota: "/escolas-geral",
        Icone: SchoolRounded,
      },
      {
        texto: "Mantenedoras",
        rota: "/mantenedora",
        Icone: AccountBalanceRounded,
      },
      {
        texto: "Modelos e Roteiros",
        rota: "/modelos",
        Icone: LibraryBooksRounded,
      },

      ...(condicao === true
        ? [
            {
              texto: "Lista de Usuários",
              rota: "/listar/users",
              Icone: GroupsOutlined,
            },
          ]
        : []),
    ];
  }

  // ESCOLA
  else if (role === "user") {
    itens = [
      {
        texto: "Início",
        rota: "/home/painel",
        Icone: HomeRounded,
      },
      {
        texto: "Dados Institucionais",
        rota: "/home/perfil",
        Icone: CorporateFare,
      },
      {
        texto: "Processos",
        rota: "/home/processos",
        Icone: FolderCopy,
      },
      {
        texto: mantenedoraRegistrada
          ? "Criar Processo"
          : "Cadastrar Mantenedora",
        rota: "/novoProcesso",
        Icone: mantenedoraRegistrada ? AddBox : AccountBalanceRounded,
      },
      {
        texto: "Cadastrar Escola",
        rota: "/cadastroEscola",
        Icone: AddHomeWork,
      },
      {
        texto: "Modelos e Roteiros",
        rota: "/modelos",
        Icone: LibraryBooksRounded,
      },
    ];
  }

  const navegarPara = (rota) => {
    navigate(rota);
    onNavigate();
  };

  return (
    <List
      sx={{
        px: visualNovo ? 1 : 0,
        py: visualNovo ? 0 : 1,
      }}
    >
      {itens.map(({ texto, rota, Icone, emDesenvolvimento = false }) => {
        const selecionado = !emDesenvolvimento && location.pathname === rota;
        const rotulo = emDesenvolvimento
          ? texto + " em desenvolvimento"
          : texto;

        return (
          <ListItemButton
            key={rota ?? texto}
            aria-label={rotulo}
            aria-disabled={emDesenvolvimento || undefined}
            selected={selecionado}
            disableRipple={emDesenvolvimento ? true : undefined}
            onClick={emDesenvolvimento ? undefined : () => navegarPara(rota)}
            sx={{
              minHeight: visualNovo ? 48 : 56,
              width: "100%",
              mb: visualNovo ? 0.5 : 0,
              px: visualNovo ? 0.5 : 2,
              justifyContent: "flex-start",
              borderRadius: visualNovo ? 2 : 0,
              color: emDesenvolvimento
                ? "text.disabled"
                : visualNovo
                  ? "var(--sear-azul, #075bb7)"
                  : "#1976d2",

              cursor: emDesenvolvimento ? "not-allowed" : undefined,
              overflow: "hidden",

              // Preserva os ícones e compacta os itens em desktops com pouca altura.
              ...(visualNovo && {
                "@media (min-width: 900px) and (max-height: 640px)": {
                  minHeight: 40,
                  py: 0,
                  mb: 0.125,
                },
              }),

              "&.Mui-selected": {
                bgcolor:
                  visualNovo && !expandido
                    ? "transparent"
                    : visualNovo
                      ? "var(--sear-superficie-hover, #e0efff)"
                      : "#e3f2fd",
                color: "var(--sear-azul, #075bb7)",
              },

              "&.Mui-selected:hover": {
                bgcolor:
                  visualNovo && !expandido
                    ? "transparent"
                    : visualNovo
                      ? "var(--sear-superficie-hover, #d5e9ff)"
                      : "#e3f2fd",
              },

              "&:hover": {
                bgcolor: emDesenvolvimento
                  ? "transparent"
                  : visualNovo && !expandido
                    ? "transparent"
                    : visualNovo
                      ? "var(--sear-superficie-hover, #edf5ff)"
                      : "#e3f2fd",
              },
            }}
          >
            {/* ÍCONE COM TOOLTIP */}
            <Tooltip
              title={
                emDesenvolvimento || (visualNovo && !expandido) ? rotulo : ""
              }
              placement="right"
              arrow
              enterDelay={250}
              disableInteractive
            >
              <ListItemIcon
                sx={{
                  minWidth: visualNovo ? 0 : 40,
                  width: visualNovo ? 40 : undefined,
                  height: visualNovo ? 40 : undefined,
                  flexShrink: 0,
                  mr: visualNovo ? 1.5 : 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  bgcolor: visualNovo
                    ? emDesenvolvimento
                      ? "action.disabledBackground"
                      : selecionado && !expandido
                        ? "var(--sear-superficie-hover, #dceeff)"
                        : "var(--sear-superficie-azul, #eaf4ff)"
                    : "transparent",

                  borderRadius: visualNovo ? 1.5 : 0,
                  color: emDesenvolvimento
                    ? "text.disabled"
                    : visualNovo
                      ? "var(--sear-azul, #087cf0)"
                      : "inherit",

                  cursor: emDesenvolvimento ? "not-allowed" : "pointer",
                }}
              >
                <Box sx={{ position: "relative", display: "flex" }}>
                  <Icone sx={{ fontSize: visualNovo ? 24 : undefined }} />

                  {emDesenvolvimento && (
                    <Box
                      aria-hidden="true"
                      sx={{
                        position: "absolute",
                        right: -5,
                        bottom: -5,
                        width: 16,
                        height: 16,
                        display: "grid",
                        placeItems: "center",
                        borderRadius: "50%",
                        bgcolor: "background.paper",
                      }}
                    >
                      <LockRounded sx={{ fontSize: 12 }} />
                    </Box>
                  )}
                </Box>
              </ListItemIcon>
            </Tooltip>

            {/* TEXTO DO MENU */}
            <ListItemText
              primary={texto}
              sx={{
                m: 0,
                minWidth: 0,
                overflow: "hidden",

                opacity: !visualNovo || expandido ? 1 : 0,

                transform:
                  visualNovo && !expandido
                    ? "translateX(-5px)"
                    : "translateX(0)",

                transition: visualNovo
                  ? expandido
                    ? [
                        "opacity 100ms ease 90ms",
                        "transform 130ms ease 70ms",
                      ].join(", ")
                    : ["opacity 55ms ease", "transform 70ms ease"].join(", ")
                  : undefined,
              }}
              primaryTypographyProps={{
                noWrap: visualNovo,

                sx: {
                  fontSize: ajustarTamanhoFonteAdmin("0.9rem"),
                  fontWeight: selecionado ? 700 : 600,
                  whiteSpace: visualNovo ? "nowrap" : "normal",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
            />
          </ListItemButton>
        );
      })}
    </List>
  );
}
